// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { render, createPortal, findDOMNode, unmountComponentAtNode } from 'react-dom';
export { Children, createClass, createElement, cloneElement, isValidElement, Component, PureComponent, Fragment } from 'react';
export { default as classNames } from 'classnames';
export { default as PropTypes } from 'prop-types';
export { default as Measure } from 'react-measure';

export const isRtl = () => getComputedStyle(document.documentElement).direction === 'rtl';

let disableDocumentScrollCounter = 0;

export const disableDocumentScroll = () => {
    disableDocumentScrollCounter = disableDocumentScrollCounter + 1;
    if (disableDocumentScrollCounter === 1) {
        const top = `${-window.pageYOffset}px`;
        document.documentElement.style.position = 'fixed';
        document.body.style.marginTop = top;
    }
};

export const enableDocumentScroll = () => {
    disableDocumentScrollCounter = disableDocumentScrollCounter - 1;
    if (disableDocumentScrollCounter === 0) {
        const scrollTop = Math.abs(parseInt(document.body.style.marginTop)) || 0;
        document.documentElement.style.position = '';
        document.body.style.marginTop = '';
        window.scrollTo(0, scrollTop);
    }
};



// WEBPACK FOOTER //
// ./utils.js